import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96bd0038"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "choose-image-wrap" }
const _hoisted_2 = { class: "content-left-box" }
const _hoisted_3 = { style: {"margin":"15px 0"} }
const _hoisted_4 = { class: "category-list-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-item-box" }, "全部", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "left-item-box" }
const _hoisted_9 = { class: "right-item-box" }
const _hoisted_10 = { class: "content-right-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_ListView = _resolveComponent("ListView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        onClick: _ctx.addGroup
      }, {
        default: _withCtx(() => [
          _createTextVNode("添加分组")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          size: "small",
          modelValue: _ctx.keyword,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
          placeholder: "请输入分类名称"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", {
          class: _normalizeClass({ selected: _ctx.categoryId == '' }),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.categoryId = ''))
        }, _hoisted_6, 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initList, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass({ selected: _ctx.categoryId == item.id }),
            onClick: ($event: any) => (_ctx.categoryId = item.id),
            key: index
          }, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_el_link, null, {
                default: _withCtx(() => [
                  _createTextVNode("编辑")
                ]),
                _: 1
              }),
              _createVNode(_component_el_divider, { direction: "vertical" }),
              _createVNode(_component_el_link, {
                onClick: _withModifiers(($event: any) => (_ctx.deleteCategory(item.id)), ["stop"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode("删除")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ], 10, _hoisted_7))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(), _createBlock(_component_ListView, {
        onConfirm: _ctx.confirm,
        modelValue: _ctx.list,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.list) = $event)),
        categoryId: _ctx.categoryId,
        key: _ctx.categoryId,
        type: _ctx.realType,
        multiple: _ctx.multiple,
        onCancel: _ctx.closeEvent
      }, null, 8, ["onConfirm", "modelValue", "categoryId", "type", "multiple", "onCancel"]))
    ])
  ]))
}